export default "__VITE_ASSET__CbN2Ie1x__"